import { useMemo, useState } from "react";
import { tasksId } from "../types/activityTasks";

let checkTheme = 0
let isPassFirsAct = false
export const useGenerateMenuActivities = (activitiesInformation = {}, returnHome = false) => {
	const [selectedTopic, setSelectedTopic] = useState(1);
	const [selectSubTopic, setSelectSubTopic] = useState(0);

	const menuGenerate = useMemo(() => {
		if (returnHome) {
			console.log('regreso');
		}
		//* variables
		let menu = {
			topicsCovered: 0,
			totalTeams: 9,
			topicsToTake: [],
		};
		let idActive = 1
		//* separar mi json en mis topics
		const valuesTopics = Object.values(tasksId);
		// //* verifico lo que tengo en mi state y veo que es lo que lleva.
		valuesTopics.forEach((topic) => {
			const valuesSubTopic = Object.values(topic.activities);
			let subTopics = [];
			let isCompleteTopic = 0;
			let checkCompleteSubTopic = [];
			valuesSubTopic.forEach((name, index) => {
				const getActivityState = activitiesInformation[name];
				if (getActivityState !== undefined) {
					let isCompleteSubTopic = false
					const isAllCompleteTask = getActivityState.task.filter((t) => t.isComplete ? true : false)
					if (getActivityState.task.length === isAllCompleteTask.length) {
						isCompleteSubTopic = true
					}
					checkCompleteSubTopic.push(isCompleteSubTopic);
					subTopics.push({ ...getActivityState, fatherId: topic.id });
				}
			});

			if (!isPassFirsAct && checkCompleteSubTopic.length > 0) {
				const inProgrees = checkCompleteSubTopic.some((check) => check);
				const completeAll = checkCompleteSubTopic.every((check) => check);
				if (inProgrees && completeAll) {
					isPassFirsAct = true
				}
			}

			if (checkCompleteSubTopic.length > 0) {
				const completeAll = checkCompleteSubTopic.every((check) => check);
				const inProgrees = checkCompleteSubTopic.some((check) => check);

				if (inProgrees) {
					isCompleteTopic = 1;
				}

				if (completeAll) {
					isCompleteTopic = 2;
					idActive = topic.id + 1
				}
			}

			if (topic.id === idActive && isCompleteTopic === 0) {
				isCompleteTopic = 1;
			}

			if (isCompleteTopic === 2) {
				checkTheme = topic.id + 1
			}


			menu.topicsToTake.push({
				id: topic.id,
				titleTopic: topic.title,
				subTopics,
				isCompleteTopic,
			});
		});
		checkTheme = checkTheme === 0 ? 1 : checkTheme

		return menu;
	}, [activitiesInformation, returnHome]);

	const getSubTopicChange = useMemo(() => {
		const findSubTopic = menuGenerate.topicsToTake.find((topic) => topic.id === selectedTopic);
		let subTopicView = [];
		let indexActivitySubTopic = -1;

		if (findSubTopic === undefined) {
			return subTopicView;
		}

		const newSubTopics = findSubTopic.subTopics.map((subtopic, index) => {
			let percentagePoints = 0;
			let isCompleteSubtopic = 0;
			const { task, points } = subtopic;

			const totalPointsWon = task.reduce((accumulator, activity) => {
				return accumulator + activity.pointsWon;
			}, 0);

			if (points !== 0) {
				percentagePoints = (totalPointsWon / points) * 100;
			}

			const completeAll = task.every((check) => check.isComplete);
			const inProgrees = task.some((check) => check.isComplete);
			if (inProgrees) {
				isCompleteSubtopic = 1;
			}

			if (completeAll) {
				if (points === 0) {
					isCompleteSubtopic = 2;
					percentagePoints = 100
				} else {
					isCompleteSubtopic = percentagePoints === 100 ? 2 : 3;
				}
			}

			if (index === 0 && isCompleteSubtopic === 0 && subtopic.fatherId === checkTheme) {
				isCompleteSubtopic = 1;
			}

			if ([2, 3].includes(isCompleteSubtopic)) {
				indexActivitySubTopic = subtopic.id + 1;
			}

			if (subtopic.id === indexActivitySubTopic) {
				isCompleteSubtopic = 1;
			}

			return { ...subtopic, percentagePoints, totalPointsWon, isCompleteSubtopic };
		});
		subTopicView = newSubTopics;
		return subTopicView;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTopic, returnHome]);

	const getActivitiesBySubTopic = useMemo(() => {
		const { subTopics } = menuGenerate.topicsToTake.find((topic) => topic.id === selectedTopic);
		let activities = [];
		let completeTask = 0;
		if (subTopics.length === 0) {
			return activities;
		}
		const findActivy = subTopics[selectSubTopic];
		if (findActivy === undefined) {
			return activities;
		}
		const newTask = findActivy.task.map((t) => {
			let percentagePoints = 0;
			if (t.points !== 0) {
				percentagePoints = (t.pointsWon / t.points) * 100;
			} else {
				percentagePoints = 100
			}
			if (t.isComplete !== undefined) {
				completeTask++;
			}
			return {
				...t,
				percentagePoints,
			};
		});
		activities = newTask;
		return { activities, completes: completeTask, total: activities.length };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedTopic, selectSubTopic, returnHome]);

	const selectTopic = (value) => {
		setSelectedTopic(value);
	};

	const selectedSubTopic = (value) => {
		setSelectSubTopic(value);
	};
	return { menuGenerate, selectTopic, selectedTopic, getSubTopicChange, selectedSubTopic, selectSubTopic, getActivitiesBySubTopic };
};
